import { ListPageContainer } from '@/components';
import { appManagementActions } from '@/redux/actions';
import paths from '@/constants/paths';
import { Tag, Typography } from "antd"
import { commonStatus } from "@/constants";

const ListPage = () => {
    return (
        <ListPageContainer
            objectName="App"
            detailUrl={paths.appManagementDetail}
            createUrl={paths.appManagementCreate}
            breadcrumbs={[
                {breadcrumbName: 'App Management'},
            ]}
            columns={[
                {title: 'AppID', dataIndex: 'id'},
                {title: 'Name', dataIndex: 'name'},
                {
                    title: 'Client app ID',
                    dataIndex: 'clientAppId',
                    render: (clientAppId) => {
                        return (
                            <Typography.Paragraph
                                style={{margin: 0}}
                                copyable={{tooltips: ['copy', 'copied!!']}}
                            >
                                {clientAppId}
                            </Typography.Paragraph>
                        )
                    }
                },
                {
                    title: 'Secret key',
                    dataIndex: 'secretKey',
                    render: (secretKey) => {
                        return (
                            <Typography.Paragraph
                                style={{margin: 0}}
                                copyable={{tooltips: ['copy', 'copied!!']}}
                            >
                                {secretKey}
                            </Typography.Paragraph>
                        )
                    }
                },
                {
                    title: 'Status',
                    dataIndex: 'status',
                    render: (status) => <Tag
                        style={{minWidth: 70, textAlign: 'center'}}
                        color={status === commonStatus.ACTIVE ? "success" : "error"}>
                        {status}
                    </Tag>
                },
            ]}
            actionBar={{
                isEdit: true,
                isCreate: true,
                isUpdateStatus: true
            }}
            getListAction={appManagementActions.getList}
            updateStatusAction={appManagementActions.updateStatus}
            disablePagination={true}
        >
        </ListPageContainer>

    )
}

export default ListPage;